// ⚙️ CONFIGURAÇÃO DO SISTEMA RAG
// Sistema: HEPATO TX RONDÔNIA
//
// ⚠️⚠️ AVISO (B230, AI_103) — `guidelinesRegistry` ABAIXO É DECORATIVO / NÃO-CANÔNICO.
// Ele NÃO governa a indexação nem reflete o corpus real. O corpus de verdade é
// indexado por um script EXTERNO (`~/Documents/hepato-rag-indexador:/indexar.js`),
// que detecta category/organization/year automaticamente e grava no Pinecone — é o
// que o reranker lê. Este registry tem ~11 entradas DESATUALIZADAS (o corpus real
// tem 68 PDFs) e até nomes errados (lista `lt_23566.pdf`; o real é `lt.23566.pdf`).
// NUNCA use este arquivo para afirmar o que está no corpus (armadilha B139 — induziu
// erro 2× na AI_102). Fonte da verdade = `.indexados.json` da pasta-fonte + metadado
// no Pinecone. Aqui só valem os parâmetros de busca/chunking/reranker (`ragConfig`).

import { RAGConfig, GuidelineConfig } from "../types";

export const ragConfig: RAGConfig = {
  // Nota (AI_87): blocos `pinecone` e `voyage` (que liam REACT_APP_*_API_KEY)
  // removidos — eram resíduo pré-B95. As chaves de API residem EXCLUSIVAMENTE
  // nas funções serverless (api/rag-search, api/rag-rerank); o cliente nunca
  // as manuseia. Mantidos aqui apenas os parâmetros de busca/chunking/reranker.
  chunking: {
    chunkSize: 1000,
    chunkOverlap: 200,
  },
  search: {
    topK: 5,
    minScore: 0.7,
  },
  reranker: {
    enabled: true,
    model: "rerank-2",
    topK: 12, // candidatos puxados do Pinecone antes do rerank
    finalTopK: 6, // chunks finais após rerank
  },
};

export const guidelinesRegistry: GuidelineConfig[] = [
  {
    filename: "lt_23566.pdf",
    title: "Liver Transplantation Guidelines",
    category: "transplante",
    organization: "ILTS",
    year: 2023,
    priority: 5,
    keywords: ["transplante", "rejeição", "imunossupressão", "tacrolimus"],
  },
  {
    filename: "vascular_liver_disorders_portal_vein_thrombosis_26.pdf",
    title: "Vascular Liver Disorders - Portal Vein Thrombosis",
    category: "complicacoes-vasculares",
    organization: "AASLD",
    year: 2020,
    priority: 5,
    keywords: ["trombose", "portal", "vascular", "anticoagulação"],
  },
  {
    filename: "aasld_practice_guidance_on_the_clinical_assessment_31.pdf",
    title: "AASLD Practice Guidance on Clinical Assessment of Cirrhosis",
    category: "cirrose",
    organization: "AASLD",
    year: 2023,
    priority: 5,
    keywords: ["cirrose", "child-pugh", "meld", "descompensação"],
  },
  {
    filename: "aasld_practice_guidance_on_prevention_diagnosis_27.pdf",
    title: "AASLD Practice Guidance on Prevention and Diagnosis of HCC",
    category: "hepatocarcinoma",
    organization: "AASLD",
    year: 2023,
    priority: 5,
    keywords: ["hepatocarcinoma", "hcc", "afp", "screening"],
  },
  {
    filename: "diagnosis_evaluation_and_management_of_ascites_38.pdf",
    title: "Diagnosis, Evaluation, and Management of Ascites",
    category: "ascite",
    organization: "AASLD",
    year: 2021,
    priority: 4,
    keywords: ["ascite", "paracentese", "pbe", "albumina"],
  },
  {
    filename: "hepatic_encephalopathy_in_chronic_liver_disease__30.pdf",
    title: "Hepatic Encephalopathy in Chronic Liver Disease",
    category: "encefalopatia",
    organization: "AASLD",
    year: 2014,
    priority: 4,
    keywords: ["encefalopatia", "amônia", "lactulose", "rifaximina"],
  },
  {
    filename: "aasld_practice_guidance_on_acute_on_chronic_liver_25.pdf",
    title: "AASLD Practice Guidance on Acute-on-Chronic Liver Failure",
    category: "cirrose",
    organization: "AASLD",
    year: 2023,
    priority: 5,
    keywords: ["aclf", "insuficiência", "aguda", "crônica"],
  },
  {
    filename: "PIIS0168827824024401.pdf",
    title: "EASL Clinical Practice Guidelines - Liver Transplantation",
    category: "transplante",
    organization: "EASL",
    year: 2024,
    priority: 5,
    keywords: ["transplante", "easl", "rejeição", "imunossupressão"],
  },
  {
    filename: "PIIS0168827824002745.pdf",
    title: "EASL Guidelines - Hepatocellular Carcinoma",
    category: "hepatocarcinoma",
    organization: "EASL",
    year: 2024,
    priority: 5,
    keywords: ["hepatocarcinoma", "hcc", "easl", "tratamento"],
  },
  {
    filename: "PIIS016882782300185X.pdf",
    title: "EASL Guidelines - Portal Hypertension",
    category: "cirrose",
    organization: "EASL",
    year: 2023,
    priority: 5,
    keywords: ["hipertensão portal", "varizes", "baveno"],
  },
];

export function getGuidelineConfig(
  filename: string
): GuidelineConfig | undefined {
  return guidelinesRegistry.find((g) => g.filename === filename);
}

export function getGuidelinesByCategory(category: string): GuidelineConfig[] {
  return guidelinesRegistry.filter((g) => g.category === category);
}
